type FileInfo = {
    id: string;
    name: string;
};

export class OPFSFileStorageProvider {
    private fsHandle!: FileSystemDirectoryHandle;

    constructor() {}

    initialize = async () => {
        this.fsHandle = await navigator.storage.getDirectory();
    };

    uploadFile = async (file: File): Promise<FileInfo> => {
        const prefix = Math.random().toString().substring(2);
        const filePath = `${prefix}-${file.name}`;

        const fileHandle = await this.fsHandle.getFileHandle(filePath, { create: true });
        const writable = await fileHandle.createWritable();
        await writable.write(file);
        await writable.close();

        return {
            id: filePath,
            name: file.name,
        };
    };

    getFileContent = async (fileId: string): Promise<string> => {
        const fileHandle = await this.fsHandle.getFileHandle(fileId);
        const file = await fileHandle.getFile();
        const blobUrl = URL.createObjectURL(file);
        return blobUrl;
    };

    deleteFile = async (fileId: string) => {
        await this.fsHandle.removeEntry(fileId);
    };
}
